


$( document ).ready(function() {
    $('.carousel').carousel({
        interval: 15000
    });



    //for the navbar animation
    if(!Cookies.get('visited')) {

        $('.navbar').addClass( "navbar-animated" );
    }
    //this cookie clears when the browser closes
    Cookies.set('visited', 1, { domain: '', path: '' });





});

